
import Vue from 'vue';
import App from './App.vue';

import VueProgressBar from 'vue-progressbar';
import Toasted from 'vue-toasted';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import BootstrapVue from 'bootstrap-vue'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import VModal from 'vue-js-modal';

import router from './core/router';
import store from './store/index';
import http from './core/http';


import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'material-design-icons/iconfont/material-icons.css';
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import './assets/fontAwesome/faall.css';
import './assets/fontAwesome/fasolid.css';
import './assets/bootstrap.custom.min.css';
import './assets/custom.css';
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'

import Clipboard from 'v-clipboard'
Vue.use(Clipboard);

import VueTour from 'vue-tour';
require('vue-tour/dist/vue-tour.css');
Vue.use(VueTour);

import VueSocketIO from 'vue-socket.io';
let options = {
  path: '/api/socket.io',
  transports: ['websocket', 'polling', 'flashsocket'],
};

Vue.use(new VueSocketIO({
  debug: false,
  connection: process.env.VUE_APP_SOCKET,
  options: process.env.VUE_APP_SOCKET === 'http://localhost:9191' ? {} : options, // pra funcionar localhost e na prod
}));

import JsonCSV from 'vue-json-csv';
Vue.component('downloadCsv', JsonCSV);

import './core/globalMixin';
import './core/filter';

library.add(fas);

//THE MASK
import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask);

import money from 'v-money';
Vue.use(money, {
  precision: 2,
  masked: true,
  decimal: ',',
  thousands: '.',
});

const VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: -100,
  force: true,
  cancelable: true,
});

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)

Vue.use(BootstrapVue);

Vue.prototype.$http = http;

Vue.config.productionTip = false;

Vue.use(Toasted, {
  iconPack: 'fontawesome', // set your iconPack, defaults to material. material|fontawesome
  position: 'top-right',
  duration: 5000,
  // theme: 'primary',
  // theme: 'bubble',
  theme: 'outline',
  icon: {
    name: 'done',
    after: true, // this will append the icon to the end of content
  },
});


Vue.use(VModal, { dynamic: true, injectModalsContainer: true, dialog: true });

Vue.use(VueProgressBar, {
  color: 'green',
  failedColor: 'red',
  height: '5px',
});

export default new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
